module.exports = __webpack_public_path__ + "static/media/cloud.03154f66.jpg";